export const BRANDS = [
  { name: "Levi's", src: "/logos/levis.svg", w: 92 },
  { name: "Lee", src: "/logos/lee.svg", w: 76 },
  { name: "Wrangler", src: "/logos/wrangler.svg", w: 132 },
  { name: "Under Armour", src: "/logos/underarmour.svg", w: 58 },
  { name: "Adidas", src: "/logos/adidas.svg", w: 64 },
  { name: "Puma", src: "/logos/puma.svg", w: 64 },
  { name: "Nike", src: "/logos/nike.svg", w: 80 },
];

export const CUSTOMERS = [
  { name: "TJ Maxx", src: "/logos/tjmaxx.svg", w: 124 },
  { name: "Marshalls", src: "/logos/marshalls.svg", w: 128 },
  { name: "HomeGoods", src: "/logos/homegoods.png", w: 124 },
  { name: "Sierra", src: "/logos/sierra.png", w: 116 },
  { name: "Winners", src: "/logos/winners.svg", w: 128 },
  { name: "Homesense", src: "/logos/homesense.svg", w: 118 },
  { name: "TK Maxx", src: "/logos/tkmaxx.svg", w: 124 },
  { name: "Burlington", src: "/logos/burlington.svg", w: 132 },
  { name: "Ross Dress for Less", src: "/logos/ross.svg", w: 96 },
];

export const SERVICES = [
  {
    id: "sourcing",
    title: "Global Merchandise Sourcing",
    text: "We locate branded apparel, footwear and accessories through manufacturers, licensees and suppliers across several regions, and match each lot to the retailers it fits.",
  },
  {
    id: "closeouts",
    title: "Branded Closeouts",
    text: "We acquire end-of-season, discontinued and overstock branded goods, review condition and assortment, and place them with off-price buyers.",
  },
  {
    id: "excess",
    title: "Excess Production Inventory",
    text: "Factories and brands often finish a run with more units than were ordered. We buy that surplus and move it into the off-price channel.",
  },
  {
    id: "distribution",
    title: "International Distribution",
    text: "We distribute merchandise across borders, coordinating between origin countries and destination markets so goods arrive where buyers need them.",
  },
  {
    id: "offprice",
    title: "Off-Price Retail Supply",
    text: "We prepare assortments to the standards of major off-price retailers: sizing, packing, labelling and delivery windows agreed in advance.",
  },
  {
    id: "logistics",
    title: "Logistics and Supply Chain Coordination",
    text: "We coordinate freight, documentation, warehousing and delivery with our logistics partners, so large-volume transactions run on schedule.",
  },
];

export const INQUIRY_TYPES = [
  { id: "suppliers", label: "Suppliers" },
  { id: "retail-buyers", label: "Retail Buyers" },
  { id: "business-partnerships", label: "Business Partnerships" },
  { id: "general", label: "General Inquiries" },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];
